import { Heading,VStack } from "@bpba/ui-components";

type ResultProps = {
  message?: string;
};

export const ResultError = (props: ResultProps) => {
  return (
    <VStack>
     <Heading level={2} fontWeight={400} children={props.message} color={"red"} tabIndex={0}/>
   </VStack>
  );
};
